export default __webpack_public_path__ + "static/media/favorite-artists-msg.a6fa5f5a.svg";